import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  UpdateProfileRequest,
  UpdateProfileResponse,
  User,
} from '../../types/userTypes'
import { activateUser, getAllUsers, updateMyProfile } from '../../api/userApi'
import { handleError } from '../../utils/errorHandler'

export const fetchUsers = createAsyncThunk<
  User[],
  void,
  { rejectValue: string }
>('users/fetchAll', async (_, thunkAPI) => {
  try {
    const response = await getAllUsers()
    return response.users
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
export const activateUserByUsername = createAsyncThunk<
  string,
  string,
  { rejectValue: string }
>('users/activateUser', async (username, thunkAPI) => {
  try {
    const response = await activateUser(username)
    return response.message
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
export const updateProfileAction = createAsyncThunk<
  UpdateProfileResponse,
  UpdateProfileRequest,
  { rejectValue: string }
>('auth/updateProfile', async (updateData, thunkAPI) => {
  try {
    const response = await updateMyProfile(updateData)
    return response
  } catch (error: any) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
